import { Route, Routes } from "react-router-dom";
import {ClosetPage} from '../pages/Closet';

const AppRoutes = () => {
    return(
        <Routes>
            {/* Main app */}
            <Route
                path="/closet"
                element={<ClosetPage />}
            />
        </Routes>
    );
}

export default AppRoutes;